import { router } from '@inertiajs/react';
import OnboardingActivity from '../../../../components/vocabulary/onboarding/OnboardingActivity';

export default function OnboardingShow(props) {
  const handleNavOut = () => router.visit('/student/dictionary');
  return (
    <OnboardingActivity
      {...props}
      onPause={handleNavOut}
      onDone={handleNavOut}
    />
  );
}
